/**
 * PURPOSE: Resolver la etiqueta visual de un participante/equipo (FTR-0006).
 * RESPONSIBILITIES: Aplicar `participant.displayName` solo donde la UI mostraría
 *   `Institution.name`; nunca reemplazar `Institution.abrev`.
 * COLLABORATORS: Equipos2, Fixture (+ useBracketData), Programacion, Resultados,
 *   Event17PublicBracket (llave pública del evento 17).
 * ROUTE: src/utils/participantDisplayName.js
 *
 * Regla exacta:
 *   - moodName === 1  -> Institution.abrev (displayName NO aplica)
 *   - moodName === 2  -> displayName?.trim() || Institution.name
 *   - Tabla de posiciones (Posiciones/*, FormatoPrint/PosicionesTable) -> siempre
 *     Institution.abrev (no usar estos helpers ahí)
 */

const normalize = (value) =>
  typeof value === "string" && value.trim() !== "" ? value.trim() : null;

// Acepta el shape legacy (`participant.Institution`, getparticipants/getmatches*) y el
// shape del bracket público del evento 17 (`participant.institution`, /event17bracket/get).
const resolveInstitution = (participant) =>
  participant?.Institution ?? participant?.institution ?? null;

/**
 * Nombre completo efectivo del participante:
 * `participant.displayName?.trim() || institution.name`.
 */
export const getParticipantFullName = (participant) => {
  if (!participant) return undefined;
  return normalize(participant.displayName) ?? resolveInstitution(participant)?.name;
};

/**
 * Etiqueta según config_category.moodName.
 * moodName 1 => abreviatura (sin override); cualquier otro valor => nombre completo efectivo.
 */
export const getParticipantLabel = (participant, moodName) => {
  if (!participant) return undefined;
  return Number(moodName) === 1
    ? resolveInstitution(participant)?.abrev
    : getParticipantFullName(participant);
};
